import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConfirmPasswordComponent } from './components/confirm-password/confirm-password.component';
import { EmailverifyComponent } from './components/emailverify/emailverify.component';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { noAuthGuard } from '../shared/auth/guards/no-auth.guard';

const routes: Routes = [
  { path: 'login',canActivate: [noAuthGuard], component: LoginComponent },
  { path: 'forgot-password', component: ResetPasswordComponent },
  { path: 'register', canActivate: [noAuthGuard],component: RegisterComponent },
  { path: 'email-verify', component: EmailverifyComponent },
  { path: 'confirm-password', component: ConfirmPasswordComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
